import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

class HomeBlogSlider {
  constructor() {
    this.init();
  }

  init() {
    new Swiper(".blog__swiper", {
      modules: [Navigation, Pagination],
      loop: false,
      slidesPerView: 1,
      spaceBetween: 24,
      pagination: {
        el: ".blog__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".blog__nav--next",
        prevEl: ".blog__nav--prev",
      },
      breakpoints: {
        640: { slidesPerView: 2, spaceBetween: 24, slidesPerGroup: 2 },
        1024: { slidesPerView: 3, spaceBetween: 32, slidesPerGroup: 3 },
      },
      speed: 600,
    });
  }
}

export default HomeBlogSlider;
